<script lang="ts" setup>
import { onMounted, onUnmounted, useRoute } from '#imports';
import { useService } from '@kaokei/use-vue-service';
import { getWechatConfigInfo } from '~/api/login';
import { LoginService } from '~/services/login.service';
import { UserService } from '~/services/user.service';
import { ZoneService } from '~/services/zone.service';
import { WX_SDK_URL } from '~/utils/constant';
import {
  recreateWechatLoginOff,
  recreateWechatLoginOn,
} from '~/utils/event-bus';
import { loadScript } from '~/utils/loadScript';

const route = useRoute();
const userService = useService(UserService);
const service = useService(LoginService);
const zoneService = useService(ZoneService);

const SITE_URL = zoneService.getWechatRedirectUrl();
const o = encodeURIComponent(window.location.origin);
const r = encodeURIComponent(window.location.href);
const redirectUri = `${SITE_URL}/callback/wechat/?o=${o}&redirect=${r}`;

const createWechatLogin = () => {
  getWechatConfigInfo().then((res) => {
    loadScript(WX_SDK_URL).then(() => {
      new WxLogin({
        self_redirect: true,
        id: 'wechat-login-qrcode-container',
        appid: res.appId,
        scope: 'snsapi_login',
        redirect_uri: encodeURIComponent(redirectUri),
        state: Date.now(),
        style: 'black',
        href: 'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZXt3aWR0aDoxOTBweDtib3JkZXI6MXB4IHNvbGlkIHJnYmEoMCwgMCwgMCwgMC4xNSk7Ym9yZGVyLXJhZGl1czo0cHh9Ci5pbXBvd2VyQm94IC50aXRsZXtkaXNwbGF5Om5vbmV9Ci5pbXBvd2VyQm94IC5pbmZve3dpZHRoOjI0MHB4fQouaW1wb3dlckJveCAuc3RhdHVze3RleHQtYWxpZ246Y2VudGVyfQouaW1wb3dlckJveCAuc3RhdHVzIHB7Y29sb3I6cmdiYSgwLCAwLCAwLCAwLjQ1KX0KLmltcG93ZXJCb3ggLnN0YXR1c19pY29ue2Rpc3BsYXk6bm9uZX0=',
      });
    });
  });
};

onMounted(() => {
  createWechatLogin();
  recreateWechatLoginOn(createWechatLogin);
});

onUnmounted(() => {
  recreateWechatLoginOff();
});
</script>

<template>
  <div>
    <div class="mb-4 text-xl font-bold text-colorText">扫描二维码登录</div>
    <div id="wechat-login-qrcode-container"></div>
  </div>
</template>

<style scoped>
:deep(#wechat-login-qrcode-container iframe) {
  width: 300px !important;
  height: 260px !important;
  margin: 0 auto;
}
</style>
